import Bootstrap from '$js/bootstrap';
import BaseModule from '$js/base/BaseModule';

new Bootstrap();

if (document.querySelector('.js-sponsors-footer')) {
  import('./modules/sponsors/footer')
    .then(({ SponsorsFooterLoader }) => {
      new SponsorsFooterLoader();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (document.querySelector('.js-toep-signup')) {
  import('./modules/toep/signup')
    .then(({ ToepSignupLoader }) => {
      new ToepSignupLoader();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (document.querySelector('.js-form-validate')) {
  import('./modules/forms/validate')
    .then(({ FormValidationLoader }) => {
      new FormValidationLoader();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}
